module.exports = __webpack_public_path__ + "img/digital-signage.65122261.png";